import { api } from '../../../api';
import { ApiResponse } from '../../Utilities';
import {
    CompanyServiceAgreementSignatureViewModel,
    CompanyServiceAgreementViewModel,
    CreateUpdateDeleteViewModel,
    ServiceAgreementContentViewModel,
} from '../../ViewModels';

export class ServiceAgreementApi {
    private route = '/ServiceAgreement';

    public getCompanyServiceAgreements(companyId: number): ApiResponse<CompanyServiceAgreementViewModel[]> {
        return api().get(`${this.route}/CompanyServiceAgreement`, { params: { companyId } });
    }

    /** The response is multipart (JSON + PDF); the current version is in the JSON part. */
    public async getCurrentServiceAgreementContent(
        serviceAgreementId: number
    ): Promise<ServiceAgreementContentViewModel> {
        const res = await api().get<string>(`${this.route}/ServiceAgreementContent`, {
            params: { serviceAgreementId },
            responseType: 'text',
        });
        const boundary = /boundary="?([^";]+)"?/.exec(res.headers['content-type'] ?? '')?.[1];
        if (!boundary) {
            throw new Error('ServiceAgreementContent response is missing its multipart boundary.');
        }
        const jsonPart = res.data.split(`--${boundary}`)[1] ?? '';
        const [content]: ServiceAgreementContentViewModel[] = JSON.parse(jsonPart.slice(jsonPart.indexOf('\r\n\r\n')));
        return content;
    }

    public postCompanyServiceAgreementSignature(
        body: CompanyServiceAgreementSignatureViewModel
    ): ApiResponse<CreateUpdateDeleteViewModel> {
        return api().post(`${this.route}/CompanyServiceAgreementSignature`, body);
    }
}
